import { useEffect, useState } from "react";

// Delay before loading videos: they start downloading this long after the window's
// load event, so the mp4s don't compete with the page's main content (or count in
// Lighthouse's measurement window).
export const VIDEO_LOAD_DELAY_MS = 3000;

// True once `delayMs` has passed after the window's load event. With no delay it is
// true from the first render.
export function useAfterLoadDelay(delayMs: number | undefined): boolean {
  const [isReady, setIsReady] = useState(delayMs === undefined);

  useEffect(() => {
    if (delayMs === undefined) return;

    let timer: ReturnType<typeof setTimeout> | undefined;
    const schedule = () => {
      timer = setTimeout(() => setIsReady(true), delayMs);
    };

    if (document.readyState === "complete") {
      schedule();
    } else {
      window.addEventListener("load", schedule, { once: true });
    }

    return () => {
      window.removeEventListener("load", schedule);
      clearTimeout(timer);
    };
  }, [delayMs]);

  return isReady;
}
